import { useQuery } from '@tanstack/react-query'
import { API_ORIGIN } from '@/constants'
import { authorizedFetch } from '@/lib/api'

export type EvaluationSummary = {
  id: string
  profile_id: string
  opportunity_id?: string | null
  final_score: number
  rank?: number | null
  was_llm_judged: boolean
}

export function useEvaluationSummary(evaluationId: string | null | undefined) {
  const query = useQuery({
    queryKey: ['evaluation', evaluationId],
    enabled: Boolean(evaluationId),
    queryFn: async (): Promise<EvaluationSummary> => {
      const response = await authorizedFetch(
        `${API_ORIGIN}/api/evaluations/${encodeURIComponent(evaluationId!)}`,
      )
      if (!response.ok) {
        throw new Error(`Failed to load evaluation (${response.status})`)
      }
      return response.json()
    },
    staleTime: 60_000,
  })

  return {
    evaluation: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
